import { ComponentType } from 'react';
import { AlgoliaCollectionHit, AlgoliaProductHit, NormalizedCollectionHit, NormalizedProductHit } from '../types';

type TProductHitComponent = ComponentType<{ hit: NormalizedProductHit; mobile: boolean }>;

type ProductHitNormalizationOprions = {
  normalizeHit: (hit: AlgoliaProductHit) => NormalizedProductHit;
  hit: AlgoliaProductHit;
  mobile: boolean;
};

/* eslint-disable react/display-name, react/function-component-definition */
export const withProductHitNormalization = (Component: TProductHitComponent) => {
  return ({ hit, normalizeHit, mobile }: ProductHitNormalizationOprions) => {
    const normalizedProductHit = normalizeHit(hit);

    return <Component hit={normalizedProductHit} mobile={mobile} />;
  };
};

type TCollectionHitComponent = ComponentType<{ hit: NormalizedCollectionHit }>;

type CollectionHitNormalizationOprions = {
  normalizeHit: (hit: AlgoliaCollectionHit) => NormalizedCollectionHit;
  hit: AlgoliaCollectionHit;
};

export const withCollecitonHitNormalization = (Component: TCollectionHitComponent) => {
  return ({ hit, normalizeHit }: CollectionHitNormalizationOprions) => {
    const normalizedCollectionHit = normalizeHit(hit);

    return <Component hit={normalizedCollectionHit} />;
  };
};
